import React from "react";

function ActiveUsers() {
  return (
    <div className="Dashboard__ActiveUsers card_box">
      <h5 className="mb-3 card_heading_holder">Active Users</h5>
      <p><span>+12.8% </span>vs Previous Month</p>

      <div className="map-holder mt-2">
        <div className="mapouter">
          <div className="gmap_canvas">
            <iframe
              className="gmap_iframe"
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://maps.google.com/maps?width=600&height=400&hl=en&q=france&t=k&z=6&ie=UTF8&iwloc=B&output=embed"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActiveUsers;
